import { FirebaseData } from "../General/FirebaseData";
import { UserData } from "../User/UserData";
import { LocalData } from "../General/LocalData";
import { FirebaseFile } from "../General/FirebaseFile";
import { Utilities } from "../../../utils/utilities";

export class ChatMessageData extends FirebaseData {
  sender?: UserData;
  message: string = "";
  sendDate?: Date;
  attachments: FirebaseFile[] = [];

  setup(data: any) {
    this.message = typeof data.message === "string" ? data.message : "";
    this.sendDate = Utilities.getDateFromTimestamp(data.sendDate);
    this.sender = typeof data.senderID === "string" ? LocalData.users.addData(data.senderID) : undefined;

    if (this.isValidObject(data.attachments)) {
      this.attachments = [];
      for (let fileId in data.attachments) {
        let fileData = data.attachments[fileId];
        const path = fileData.path;
        const file = new FirebaseFile(path);
        file.id = fileId;
        file.title = fileData.name;
        file.fileType = fileData.type;
        this.attachments.push(file);
      }
    }
    super.setup(data);
  }
}

